@if (archive) {
	<div id="record-adjustment" class="panel highlight">
		<div class="heading">Record {{archive.operation_id === 0 ? "baseline" : "new"}} adjustment</div>
		<div class="content">
			<div class="row">
				<div class="col-lg-6">
					<p>Adjustments:</p>
					<app-adjustment-grid [rotor]="rotor" [adjustments]="archive.adjustments" [mode]="isH60 ? 'h60' : 'number'"></app-adjustment-grid>
					@if (archive.isClockwise) {
						<p class="mt-2">Note: blade is clockwise</p>
					}
				</div>
				<div class="col-lg-6">
					@if (archive.operation_id !== 0) {
						<p>Adjustment generated from operation: {{archive.operation_start | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</p>
						<div class="mb-3">
							<label>User note:</label>
							<div>
								<textarea [(ngModel)]="userNote" class="form-control" style="min-height: 150px;"></textarea>
							</div>
						</div>
					}
					<app-action-button [action]="UploadAdjustment" [context]="this" processing="Saving..." complete="Adjustment recorded" btnClass="green">Record
						adjustment</app-action-button>
					<button (click)="CancelAdjustment()" class="button ms-2">Cancel</button>
				</div>
			</div>
		</div>
	</div>
}
<div class="row">
	<div class="col-lg-4">
		<app-regime-list [regimes]="regimeCounts" (evaluateChange)="regimesChange()"></app-regime-list>
		@if (regimeCounts && regimeCounts.length && rotor.balancedata && rotor.balancedata.numblades >= 4) {
			<app-shaft-order [(shaftOrder)]="shaftOrder" (refresh)="loadRegimes()"></app-shaft-order>
		}
		@if (regimeCounts && regimeCounts.length) {
			<div class="row">
				<div class="col-4">
					Sensor
				</div>
				<div class="col-8">
					@for (vshaft of vshafts; track vshaft) {
						<div class="form-check">
							<label>
								<input [(ngModel)]="selectedVShaft" name="vshaft" type="radio" [value]="vshaft" (ngModelChange)="loadRegimes()">
								{{vshaft.name}} ({{vshaft.shftid}})
							</label>
						</div>
					}
				</div>
			</div>
		}
	</div><!-- End left column -->
	<div class="col-lg-8">
		<div class="panel">
			<div class="heading">Averages (polar)</div>
			<div class="content">
				<app-dvs-chart #polarChart [options]="polarOptions" loading="Loading vibration data" [error]="errormessage" [height]="'600px'"
					[timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
			</div>
		</div>
	</div>
</div>
<div class="panel">
	<div class="heading">Averages (timeline)</div>
	<div class="content">
		<app-dvs-chart #timelineChart [options]="timelineOptions" loading="Loading vibration data" [error]="errormessage" [height]="'200px'"
			[timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
		@if (timelineOptions && adjustments && adjustments.length) {
			<div class="chart-legend">
				<span class="legend-item">
					<span class="swatch adjustment"></span> Adjustment (see below)
				</span>
			</div>
		}
	</div>
</div>
<app-adjustment-history [asset]="asset" [rotor]="rotor" [adjustments]="adjustments" (createBaseline)="CreateBaseline()"
	(adjustmentDeleted)="updateAdjustments(); regimesChange();"></app-adjustment-history>